import "core-js/modules/es.promise.finally.js";
import { useRef as n, useEffect as t, useState as r, useLayoutEffect as e, createRef as o, useMemo as i, useCallback as u } from "react";
import c from "lodash/debounce";
import a from "lodash/isEqual";
import f from "lodash/isUndefined";

function l(n, t) {
  var r = Object.keys(n);

  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(n);
    t && (e = e.filter(function (t) {
      return Object.getOwnPropertyDescriptor(n, t).enumerable;
    })), r.push.apply(r, e);
  }

  return r;
}

function v(n) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? l(Object(r), !0).forEach(function (t) {
      y(n, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : l(Object(r)).forEach(function (t) {
      Object.defineProperty(n, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }

  return n;
}

function d(n) {
  return (d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
    return typeof n;
  } : function (n) {
    return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  })(n);
}

function y(n, t, r) {
  return t in n ? Object.defineProperty(n, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[t] = r, n;
}

function s(n, t) {
  return function (n) {
    if (Array.isArray(n)) return n;
  }(n) || function (n, t) {
    var r = null == n ? null : "undefined" != typeof Symbol && n[Symbol.iterator] || n["@@iterator"];
    if (null == r) return;
    var e,
        o,
        i = [],
        u = !0,
        c = !1;

    try {
      for (r = r.call(n); !(u = (e = r.next()).done) && (i.push(e.value), !t || i.length !== t); u = !0) {
        ;
      }
    } catch (n) {
      c = !0, o = n;
    } finally {
      try {
        u || null == r.return || r.return();
      } finally {
        if (c) throw o;
      }
    }

    return i;
  }(n, t) || b(n, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function p(n) {
  return function (n) {
    if (Array.isArray(n)) return m(n);
  }(n) || function (n) {
    if ("undefined" != typeof Symbol && null != n[Symbol.iterator] || null != n["@@iterator"]) return Array.from(n);
  }(n) || b(n) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function b(n, t) {
  if (n) {
    if ("string" == typeof n) return m(n, t);
    var r = Object.prototype.toString.call(n).slice(8, -1);
    return "Object" === r && n.constructor && (r = n.constructor.name), "Map" === r || "Set" === r ? Array.from(n) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? m(n, t) : void 0;
  }
}

function m(n, t) {
  (null == t || t > n.length) && (t = n.length);

  for (var r = 0, e = new Array(t); r < t; r++) {
    e[r] = n[r];
  }

  return e;
}

function h(r, e) {
  var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
      i = o.options,
      u = o.enabled,
      c = void 0 === u || u,
      a = o.dependencies,
      f = void 0 === a ? [c, r] : a,
      l = o.element,
      y = n(function () {});
  t(function () {
    y.current = e;
  }, [e]), t(function () {
    if (!1 !== c) {
      if ("once" === c || !0 === c) {
        var n = function n(_n) {
          return y.current(_n);
        },
            t = v(v({}, i), {}, {
          once: "once" === c
        });

        return (null != l ? l : document).addEventListener(r, n, t), function () {
          (null != l ? l : document).removeEventListener(r, n, t);
        };
      }

      console.error("Received value of type ".concat(d(c), " for property `enabled`. Expected a boolean."));
    }
  }, f);
}

function g(n, e, o) {
  var i = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
      u = r(),
      c = s(u, 2),
      a = c[0],
      f = c[1];
  return t(function () {
    if (i) {
      var t = new MutationObserver(function () {
        f(o.apply(void 0, arguments));
      });
      return n && t.observe(n, e), function () {
        return t.disconnect();
      };
    }
  }, [n, e, o, i]), a;
}

function w() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
}

function O() {
  var n = s(r(null), 2),
      e = n[0],
      o = n[1];
  return t(function () {
    o(w());
    var n = c(function () {
      return o(w());
    }, 100);
    return window.addEventListener("resize", n), function () {
      return window.removeEventListener("resize", n);
    };
  }, []), e;
}

var j = function j(n, t) {
  return h("keydown", function (t) {
    return function (n, t) {
      27 === n.keyCode && (n.stopImmediatePropagation(), t());
    }(t, n);
  }, t);
};

function S() {
  var n = function n() {
    return "visible" === document.visibilityState;
  },
      e = s(r(!0), 2),
      o = e[0],
      i = e[1];

  return t(function () {
    i(n);
  }, []), h("visibilitychange", function () {
    i(n);
  }), o;
}

function A(r) {
  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      o = e.interval,
      i = void 0 === o ? 3e4 : o,
      u = e.immediate,
      c = void 0 === u || u,
      a = e.enabled,
      f = void 0 === a || a,
      l = n(),
      v = S(),
      d = v && f;
  t(function () {
    l.current = r;
  }), t(function () {
    var n;
    if (d) return c ? e() : t(), r;

    function t() {
      r(), n = setTimeout(e, i);
    }

    function r() {
      clearTimeout(n);
    }

    function e() {
      var n;
      Promise.resolve(null === (n = l.current) || void 0 === n ? void 0 : n.call(l)).finally(t);
    }
  }, [i, c, d]);
}

function E(r) {
  var e = n();
  return t(function () {
    e.current = r;
  }), e.current;
}

function P(t) {
  var r = n();
  return void 0 !== r.current && a(r.current, t) || (r.current = t), r.current;
}

var I = function I() {
  var n = "undefined" == typeof window ? t : e;
  return n.apply(void 0, arguments);
},
    x = !1,
    C = new Map(),
    D = function D(n) {
  if (C.has(n)) {
    var t = C.get(n),
        r = t ? t + 1 : 1;
    return C.set(n, r), r;
  }

  return C.set(n, 1), 1;
};

function k(n) {
  var e = n.prefix,
      o = n.id,
      i = e && (x ? D(e) : null),
      u = s(r(i), 2),
      c = u[0],
      a = u[1];
  return I(function () {
    e && null === c && a(D(e));
  }, []), t(function () {
    !1 === x && (x = !0);
  }, []), o || "".concat(e, "-").concat(c);
}

function L(n) {
  var t = s(r(!1), 2),
      e = t[0],
      o = t[1];
  if (f(n) || "function" != typeof n) return {
    onBlur: function onBlur() {},
    onChange: function onChange() {}
  };
  return {
    onBlur: function onBlur(t) {
      o(!0), null == n || n(t.target.value);
    },
    onChange: function onChange(t) {
      e && (null == n || n(t.target.value));
    }
  };
}

var M = new Map();

function T(n) {
  return function () {
    var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";

    function t(t) {
      if (t) {
        var r = n + "-" + t;
        if (M.get(r)) return M.get(r);
        var e = o();
        return M.set(r, e), e;
      }

      console.error("useDynamicRefs: Cannot get ref without key");
    }

    return t;
  }(n.prefix);
}

function z(t) {
  var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      e = r.initialValue,
      o = r.deps,
      u = void 0 === o ? [] : o,
      c = n(e);
  return i(function () {
    return {
      get current() {
        return c.current;
      },

      set current(n) {
        c.current = n, t(n);
      }

    };
  }, [t, c].concat(p(u)));
}

function B(n, t) {
  var r = u(function (n, t) {
    Array.isArray(n) ? n.forEach(r) : "function" == typeof n ? n(t) : n && (n.current = t);
  }, []);
  return z(u(function (t) {
    return r(n, t);
  }, [n, r]), {
    initialValue: t
  });
}

export { T as useDynamicRefs, j as useEscapeKey, h as useEventListener, B as useForwardedRef, k as useIdAllocator, I as useIsomorphicLayoutEffect, g as useMutationObserver, P as useObjectDependency, z as useObservedRef, A as usePoller, E as usePrevious, L as useValidation, O as useViewportSize };